import { actions, selectors } from './';
import { selectors as accountSelectors } from '../account';
import { connect } from '../store/connect';
import { AUTHORIZATIONS } from '../authorizations/authorizations';
import { HistoryBase } from '../util/history-base';
const { CAN_SEE_SITE_HISTORY } = AUTHORIZATIONS;

class SiteHistory extends HistoryBase {
    static get properties() {
        return {
            ...super.properties,
            siteGuid: {
                type: String,
            },
            sport: {
                type: String,
            },
        };
    }

    get historyTitle() {
        return 'Site History';
    }

    get emptyMessage() {
        return 'No history found for this site.';
    }

    get fieldColumnWidth() {
        return '360px';
    }

    updated(changedProps) {
        if (changedProps.has('siteGuid')) {
            const { siteGuid, sport, authorizations } = this;
            if (authorizations?.includes(CAN_SEE_SITE_HISTORY) && siteGuid && sport) {
                this.actions.fetchSiteHistory({ guid: siteGuid, sport });
            }
        }
    }
}

const mapStateToProps = (state, ownProps) => {
    return (state) => {
        const siteData = selectors.siteStagedEditsSelector(state);
        return {
            siteGuid: siteData?.guid,
            sport: siteData?.sport || selectors.siteSportSelector(state),
            authorizations: accountSelectors.accountAuthorizationsSelector(state),
            historyRecords: selectors.siteHistoryRecordsSelector(state),
            isLoadingHistory: selectors.isLoadingSiteHistorySelector(state),
        };
    };
};

const combinedActions = {
    ...actions,
};

customElements.define('site-history', connect(mapStateToProps, combinedActions)(SiteHistory));
